import { useState } from 'react'
import { X } from 'lucide-react'

// AdSpeed AS.Zones.create accepts type='display'|'email'|'video'.
const ZONE_TYPES = [
  { value: 'display', label: 'Display (banner/web)' },
  { value: 'video',   label: 'Video (CTV / VAST)' },
  { value: 'email',   label: 'Email' },
]

// NOTE: zone status changes are NOT supported by AdSpeed's API.
// AS.Zone.edit accepts: name, secondary, optimizer, descr — no `status`
// field. Archiving/activating zones must be done in AdSpeed's dashboard.

export default function ZoneEditor({ initial = null, onClose, onSubmit }) {
  const isEdit = !!initial
  const [name, setName] = useState(initial?.name || initial?.Name || '')
  const [descr, setDescr] = useState(initial?.Description || initial?.description || '')
  const [type, setType] = useState(initial?.type || initial?.Type || 'display')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (!name.trim()) {
      setError('Name is required')
      return
    }
    if (name.trim().length > 50) {
      setError('Name must be 50 characters or fewer (AdSpeed limit)')
      return
    }
    setSaving(true)
    try {
      const body = { name: name.trim() }
      if (!isEdit) body.type = type
      if (descr.trim()) body.descr = descr.trim()
      await onSubmit(body)
    } catch (err) {
      setError(err.message)
    }
    setSaving(false)
  }

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#121212', border: '1px solid #333', borderRadius: 10,
          padding: 24, minWidth: 440, maxWidth: 560,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: '1.2rem' }}>
            {initial ? 'Edit Zone' : 'New Zone'}
          </h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: '#aaa', cursor: 'pointer',
          }}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: '0.85rem', color: '#aaa', marginBottom: 4 }}>
              Name
            </label>
            <input
              autoFocus
              value={name}
              onChange={e => setName(e.target.value)}
              className="zones-search"
              style={{ width: '100%' }}
              placeholder="e.g. PIHL Game Stream — Pre-roll"
            />
          </div>

          {!isEdit && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', color: '#aaa', marginBottom: 4 }}>
                Type
              </label>
              <select
                value={type}
                onChange={e => setType(e.target.value)}
                className="zones-search"
                style={{ width: '100%' }}
              >
                {ZONE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
              <div className="muted" style={{ fontSize: '0.72rem', marginTop: 4 }}>
                Type cannot be changed after creation.
              </div>
            </div>
          )}

          {isEdit && (
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', color: '#aaa', marginBottom: 4 }}>
                Status
              </label>
              <div className="muted" style={{ fontSize: '0.85rem', padding: '6px 10px', background: '#1a1a1a', borderRadius: 4, border: '1px solid #333' }}>
                Current: <strong>{initial?.status || initial?.Status || 'unknown'}</strong>
              </div>
              <div className="muted" style={{ fontSize: '0.72rem', marginTop: 4 }}>
                Zone status (active / pending / archived / deleted) cannot be
                changed via AdSpeed's API — only through the AdSpeed dashboard.
                Ads support status changes via API; zones do not.
              </div>
            </div>
          )}

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: '0.85rem', color: '#aaa', marginBottom: 4 }}>
              Description (optional)
            </label>
            <input
              value={descr}
              onChange={e => setDescr(e.target.value)}
              className="zones-search"
              style={{ width: '100%' }}
              placeholder="e.g. PIHL Game Stream — Pre-roll slot"
            />
          </div>

          {error && (
            <div className="sponsors-status error" style={{ marginBottom: 12 }}>{error}</div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button type="button" onClick={onClose} className="sponsors-refresh-btn">
              Cancel
            </button>
            <button type="submit" disabled={saving} className="btn btn-primary">
              {saving ? 'Saving…' : (initial ? 'Save' : 'Create')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
